import DataTable from '@/containers/data_table_ml/DataTable';
import { versionStatus, approvalStatus } from '@/constants.js';
import ButtonML from '@/components/button_ml/ButtonML';
import Action from '../action/Action';
const TablePage = (props) => {
  const { loadingstatus, tableData, pushDecisionGraphMap } = props || {};
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 100,
      align: 'center',
    },
    {
      title: '决策图名称',
      dataIndex: 'name',
      key: 'name',
      width: 200,
    },
    {
      title: '版本号',
      dataIndex: 'version',
      key: 'version',
      align: 'center',
      width: 100,
      render: (recor, detail) => {
        return (
          <ButtonML
            type="link"
            size="large"
            value={recor}
            onClick={() => pushDecisionGraphMap(detail)}
          />
        );
      },
    },
    {
      title: '版本描述',
      dataIndex: 'versionDescription',
      key: 'versionDescription',
      width: 200,
    },
    {
      title: '提交人',
      dataIndex: 'submitStaff',
      key: 'submitStaff',
      width: 100,
    },
    {
      title: '审批人',
      dataIndex: 'approvalStaff',
      key: 'approvalStaff',
      width: 100,
      align: 'center',
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 100,
      align: 'center',
    },
    {
      title: '上线时间',
      dataIndex: 'onlineTime',
      key: 'onlineTime',
      width: 100,
      align: 'center',
    },
    {
      title: '下线时间',
      dataIndex: 'offlineTime',
      key: 'offlineTime',
      width: 100,
      align: 'center',
    },
    {
      title: '审批状态',
      dataIndex: 'approvalStatus',
      key: 'approvalStatus',
      width: 100,
      render: (text) => {
        return approvalStatus[text];
      },
    },
    {
      title: '版本状态',
      dataIndex: 'versionStatus',
      key: 'versionStatus',
      width: 100,
      render: (text) => {
        return versionStatus[text];
      },
    },
    {
      title: '操作',
      render: (record) => {
        return <Action singleListInfo={record} />;
      },
      // fixed: 'right',
      width: 380,
    },
  ];
  return (
    <DataTable
      className="demo-test"
      // style={{ minWidth: '1547px' }}
      columns={columns}
      rowSelection={false}
      // pagination={pagination}
      scroll={{
        x: 1547,
        y: 'calc(100vh - 64px - 46px - 47px - 60px - 2rem)',
      }}
      loading={loadingstatus}
      dataSource={tableData}
      // changePage={(a) => {
      //   props.pageNumChange(a);
      // }}
      // changePageSize={(a) => {
      //   props.pageSizeChange(a);
      // }}
    />
  );
};
export default TablePage;
